/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { IdentityServerApiConfig } from '../api-config';

import { IdentityServerApi } from '../models';

@Injectable()
export class UsersApiClient extends BaseApiClient<IdentityServerApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.identityServerApiConfig);
  }

  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersActivateByuserId(
    params: { body: IdentityServerApi.ActivateUserRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<IdentityServerApi.UserDto>(
      `${this.basePath}/gateway/admin/users/activate/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersBlockByuserId(
    params: { body: IdentityServerApi.BlockUserRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<IdentityServerApi.UserDto>(
      `${this.basePath}/gateway/admin/users/block/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDto>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDto>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDto>>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDto>>;
  usersControllerPostApiIdentityUsers(
    params: { body: IdentityServerApi.CreateUserRequest; xSgUser?: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<IdentityServerApi.UserDto>(
      `${this.basePath}/gateway/admin/users`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDto>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDto>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDto>>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDto>>;
  usersControllerGetApiIdentityUsersByid(
    params: { xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<IdentityServerApi.UserDto>(
      `${this.basePath}/gateway/admin/users/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDto>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDto>>;
  usersControllerPutApiIdentityUsersByuserId(
    params: { body: IdentityServerApi.UpdateUserRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<IdentityServerApi.UserDto>(
      `${this.basePath}/gateway/admin/users/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>>;
  usersControllerPostApiIdentityUsersSearch(
    params: {
      body: IdentityServerApi.SearchUsersRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'userName';
    },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'sortDirection', params.sortDirection],
      ['', 'orderBy', params.orderBy]
    );

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<IdentityServerApi.UserDtoSearchUsersOrderPagingResultDto>(
      `${this.basePath}/gateway/admin/users/search`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<any>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<any>>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<any>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<any>>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<any>>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<any>>;
  usersControllerPutApiIdentityUsersResetPasswordByuserId(
    params: { body: IdentityServerApi.ResetPasswordMailRequest; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<any>(
      `${this.basePath}/gateway/admin/users/resetPassword/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
